import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"
import profileBuilder from "../pages/Authentication/profile-builder"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Home from "../pages/Authentication/home"
import Logout from "../pages/Authentication/Logout"
import AuthCheck from "../pages/Authentication/authCheck"
import AuthError from "../pages/Authentication/authError"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
// import Notifications from "../pages/notifications/index"
import Speakers from "pages/speakers"
import Leaderboard from "pages/Leaderboard"
import Gratitude from "pages/Gratitude/Gratitude"
import ActivityFeed from "pages/ActivityFeed/ActivityFeed"
import Mylibrary from "pages/MyLibrary/Mylibrary"
import Networking from "pages/networkingZone"
import Weather from "pages/Weather/waether"
import Feedback from "pages/Feedback/feedback"
import Feedback2 from "pages/Feedback/feedback2"
import MobileCarousel from "pages/Carousel/carousel"

import Attendee from "pages/Attendee/attendee"
import AttendeeProfile from "pages/Attendee/profile"
import Preferences from "pages/PreferencesChat/preferences"
import Agenda from "pages/Agenda/agenda"
import IndoorMap from "pages/IndoorMaps/IndoorMap"

//Blog
import BlogList from "../pages/Blog/BlogList/index"
import BlogGrid from "../pages/Blog/BlogGrid/index"
import BlogDetails from "../pages/Blog/BlogDetails"
import QrScanComponent from "components/Common/QrScanComponent"
import UserBadge from "pages/UserBadge/UserBadge"
import WrappedBadge from "pages/UserBadge/wrappedBadge"
import Inventory from "pages/Inventory/Inventory"
import WalmartAnalysis from "pages/WalmartAnalysis/WalmartAnalysis"
import Quiz from "pages/Quiz/Quiz"
import LeaderboardPodium from "pages/Leaderboard/LeaderboardPodium"

const userRoutes = [
  { path: "/dashboard", objct: {}, component: Dashboard },

  // { path: "/sendnotification", objct:{},component: Notifications },

  // //profile
  { path: "/profile", objct: {}, component: UserProfile },

  // //profile-builder / flighttickets
  { path: "/flighttickets", objct: {}, component: profileBuilder },

  // //speakers
  { path: "/speakers", objct: {}, component: Speakers },

  // //leaderboard
  { path: "/leaderboard1", objct: {}, component: Leaderboard },

  // //leaderboard — new podium + scrollable table page
  { path: "/leaderboard", objct: {}, component: LeaderboardPodium },

  // //Networking
  { path: "/networking", objct: {}, component: Networking },

  // //Gratitude
  { path: "/Grantitude", objct: {}, component: Gratitude },

  // //Mylibrary
  { path: "/mylibrary", objct: {}, component: Mylibrary },

  { path: "/inventory", objct: {}, component: Inventory },

  { path: "/walmartAnalysis", objct: {}, component: WalmartAnalysis },

  // //ActivityFeed
  { path: "/ActivityFeed", objct: {}, component: ActivityFeed },

  { path: "/map", objct: {}, component: IndoorMap },

  { path: "/Carousel", objct: {}, component: MobileCarousel },

  { path: "/weather", objct: {}, component: Weather },

  { path: "/feedback", objct: {}, component: Feedback },

  { path: "/feedback2", objct: {}, component: Feedback2 },


  //User Badge
  { path: "/userbadge", objct: {}, component: UserBadge },

  {path: "/wrappedBadge", objct: {}, component: WrappedBadge },

  { path: "/attendee", objct: {}, component: Attendee },

  { path: "/attendeeProfile", objct: {}, component: AttendeeProfile },

  { path: "/preferences", objct: {}, component: Preferences },

  { path: "/agenda", objct: {}, component: Agenda },

  // //Quiz
  { path: "/quiz", objct: {}, component: Quiz },

  { path: "/qr", objct: {}, component: QrScanComponent },


  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/page/lobby" /> },

  //Blog
  { path: "/blog-list", component: BlogList },
  { path: "/blog-grid", component: BlogGrid },
  { path: "/blog-details", component: BlogDetails },
]

const authRoutes = [
  { path: "/qr", objct: {}, component: QrScanComponent },
  { path: "/logout", objct: {}, component: Logout },
  { path: "/login", objct: {}, component: Login },
  { path: "/home", objct: {}, component: Home },
  { path: "/login/check", objct: {}, component: AuthCheck },
  { path: "/login/fail", objct: {}, component: AuthError },
]

export { userRoutes, authRoutes }